import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { CircularProgress } from '@material-ui/core';
import styled from 'styled-components';
var CleanLoading = function (options) { return (React.createElement(CircularProgress, { "data-testid": options.testId, className: options.className })); };
export var Loading = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanLoading, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n  font-size: 20px;\n"], ["\n  padding: 10px;\n  font-size: 20px;\n"])));
var templateObject_1;
//# sourceMappingURL=Loading.js.map